import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import MonthlyClosing, { IGetMonthlyClosingDto } from "./MonthlyClosing"

export interface IGetMonthlyClosingsDto {
    isAssetSplitRunning: boolean
    entities?: IGetMonthlyClosingDto[]
    links?: IApiLink[]
}

export default class MonthlyClosings {
    isAssetSplitRunning: boolean
    items: MonthlyClosing[]
    createLink?: IApiLink
    forecastReportLink?: IApiLink

    constructor({
        isAssetSplitRunning,
        entities,
        links
    }: IGetMonthlyClosingsDto) {
        this.isAssetSplitRunning = isAssetSplitRunning
        this.items = entities?.map(mcDto => new MonthlyClosing(mcDto)) || []
        this.createLink = links?.find(lnk => lnk.entity === ApiLinkEntity.monthlyClosing && lnk.rel === ApiLinkRel.new)
        this.forecastReportLink = links?.find(lnk => lnk.entity === ApiLinkEntity.forecastReport && lnk.rel === ApiLinkRel.self)
    }
}
